import React, { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import CustomerClubImg from "../assets/image/64-removebg-preview.png";
import StepperComponent from "../components/stepper.tsx";
import { CacheProvider } from "@emotion/react";
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import getReq from "../interface/getRequestinterface";
import { getRequest } from "../request";

const listOfColors = {
  gold: "#ffd700",
  goldbtn: "#d3bd48",
  silver: "#C0C0C0",
  silverbtn: "#7f7f7f",
  bronze: "#CD7F32",
  bronzebtn: "#886644",
};
interface CharnseAmount {
  id: number;
  maximum_Charense: number;
  minimum_Charense: number;
  title_Level: string;
}

function CustomerClubHint() {
  const navigate = useNavigate();
  const [charnseAmount, setCharnseAmount] = useState<Array<CharnseAmount>>([]);
  const theme = useTheme();
  const style = {
    returnSection: {
      width: "70%",
      fontSize: "1.7rem",
      fontWeight: "700",
      textAlign: "center",
      margin: "3rem 0rem",
      padding: "1rem",
      cursor: "pointer",
      borderRadius: "0.7rem",
      color: "#fff",
      backgroundColor: `${theme.palette.primary.main}`,
    },
    headerBox: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      marginTop: "2rem",
    },
    headerImg: {
      backgroundColor: "rgb(192 237 255 / 48%)",
      borderRadius: "3px",
      width: "45rem",
      margin: "3rem 0rem",
      boxShadow:
        "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
    },
    headerImgMobile: {
      backgroundColor: "rgb(192 237 255 / 48%)",
      borderRadius: "3px",
      width: "20rem",
      margin: "3rem 0rem",
      boxShadow:
        "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
    },
    mainBox: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      width: "80%",
      marginTop: "2rem",
    },
    boxSection: {
      width: "70%",
      fontSize: "1.7rem",
      fontWeight: "bold",
      textAlign: "justify",
      marginTop: "3rem",
      color: `${theme.palette.secondary.main}`,
    },
    subSection: { width: "70%", fontSize: "1.2rem", textAlign: "justify" },
  };
  const cacheRtl = useMemo(() => {
    return createCache({
      key: "muirtl",
      stylisPlugins: [prefixer, rtlPlugin],
    });
  }, []);
  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const isTablet = useMediaQuery({
    query: "((min-width:650px) and (max-width: 900px))",
  });

  const isMobile = useMediaQuery({
    query: "(max-width: 600px)",
  });
  const fetchCharnseAmount = async () => {
    const { data, error }: getReq = (await getRequest(
      `${process.env.REACT_APP_BASE_URL}/User/User_List_Level`
    )) as getReq;
    if (!error) {
      setCharnseAmount(data);
    }
  };
  useEffect(() => {
    fetchCharnseAmount();
  }, []);

  return (
    <CacheProvider value={cacheRtl}>
      <div className="background">
        <Box sx={style.headerBox}>
          <Alert
            severity="info"
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1.5rem",
            }}
          >
            <Typography variant="h4" color="initial">
              راهنمای استفاده از باشگاه مشتریان
            </Typography>
          </Alert>
          <Box sx={style.subSection}>
            باشگاه مشتریان صرافی کاریزما باهدف ایجاد محیطی پویا به‌منظور ارتقا و
            بهبود خدمات و در راستای مشتری مداری و جلب رضایت مشتریان محترم،
            پایه‌ریزی شده است. هر شخص این امکان را دارد تا ضمن عضویت در این
            باشگاه، از مزایا و امکانات آن بهره‌مند شود.
            <br />
            باشگاه مشتریان صرافی کاریزما با شعار
            <b> “به قله توانایی های خود صعود کنید” </b>، در نظر دارد تا با فراهم
            آوردن محیطی پویا برای فعالیت‌های صورت گرفته توسط اعضا، به آنان
            امتیاز متناسب با فعالیتشان تخصیص دهد.
          </Box>
          <img
            src={CustomerClubImg}
            alt=""
            style={isMobile ? style.headerImgMobile : style.headerImg}
          />
          <Box sx={style.subSection}>
            در ادامه نحوه عضویت، امکانات موجود و مزایای مربوط به مشتریان و
            کاربران در سطوح مختلف باشگاه، توضیح داده خواهد شد.
          </Box>

          <Box sx={style.boxSection}>
            1- عضویت در باشگاه مشتریان صرافی کاریزما
          </Box>
          <Box sx={style.subSection}>
            به منظور سهولت دسترسی کاربران محترم، تمامی مشتریانی که نسبت به خرید
            ارز در سامانه سنا از صرافی کاریزما اقدام نموده اند،
            <b> به صورت خودکار </b>
            در باشگاه مشتریان صرافی کاریزما نیز ثبت عضویت می شوند.
          </Box>
          {/* //////////////////////////////////////////// */}
          <Box sx={style.boxSection}>2- مراحل تخصیص سرویس باشگاه مشتریان</Box>

          <Box sx={{ width: "80%", margin: "1rem 0rem" }}>
            <StepperComponent />
          </Box>
          {/* ///////////////////////////////////////////// */}
          <Box sx={style.boxSection}>3- نحوه محاسبه امتیازات و سطح بندی</Box>
          <Box sx={style.subSection}>
            هر واحد امتیازی در باشگاه مشتریان صرافی کاریزما<b> کارنس </b> نام
            دارد، به ازای هر
            <b> 10 هزار معادل درهمی </b>
            معاملات انجام شده در 6 ماه اخیر یک کارنس در نظر گرفته خواهد شد.
            مشتریان محترم بر اساس کارنس دریافتی در سه سطح
            <b style={{ color: `${listOfColors.gold}` }}> طلایی </b>،
            <b style={{ color: `${listOfColors.silver}` }}> نقره ای </b>و
            <b style={{ color: `${listOfColors.bronze}` }}> برنزی </b>
            دسته بندی خواهند شد. سطوح امتیازی به صورت جدول زیر می باشد :
          </Box>

          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              margin: "3rem 0rem",
            }}
          >
            <TableContainer
              component={Paper}
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "fit-content",
              }}
            >
              <Table
                sx={isMobile ? { width: "20rem" } : { width: "40rem" }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell className="ratesTh" align="center">
                      سطح
                    </TableCell>
                    <TableCell className="ratesTh" align="center">
                      حداقل امتیاز (کارنس) مورد نیاز
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {charnseAmount?.map((x) => (
                    <TableRow
                      key={x.id}
                      className="ratesTr"
                      sx={{ "&:last-child , &:last-child": { border: 0 } }}
                    >
                      <TableCell className="ratesTd" align="center">
                        {x.title_Level}
                      </TableCell>
                      <TableCell className="ratesTd" align="center">
                        {x.minimum_Charense}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {/* //////////////////////////////////////// */}
          <Box sx={style.boxSection}>
            4- برخی از سرویس های باشگاه مشتریان صرافی کاریزما
          </Box>
          <Box
            sx={{
              width: "70%",
              fontSize: "1.2rem",
              textAlign: "justify",
            }}
          >
            <ul style={{ listStyleType: "disc" }}>
              <li>• ارائه تخفیف کارمزد در معاملات آتی</li>
              <li>• کارت هدیه</li>
              <li>• تخصیص امتیاز به فعالیت های خیرخواهانه و نیکوکاری</li>
            </ul>
          </Box>
          <Box
            sx={style.returnSection}
            onClick={() => navigate("/costumerServicesList")}
          >
            بازگشت به باشگاه مشتریان
          </Box>
        </Box>
      </div>
    </CacheProvider>
  );
}

export default CustomerClubHint;
